// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yDezc{margin:auto;padding-top:30px;padding-bottom:50px}._1DwrD{margin-bottom:30px}", ""]);
// Exports
exports.locals = {
	"container": "yDezc",
	"title": "_1DwrD"
};
module.exports = exports;
